import Dial from "../../../../assets/svg/SocialMediaIcons/dial"
import LinkedinWhite from "../../../../assets/svg/SocialMediaIcons/linkedinwhite"
import Location from "../../../../assets/svg/SocialMediaIcons/location";
import Mail from "../../../../assets/svg/SocialMediaIcons/mail"
import Clock from '../../../../assets/svg/SocialMediaIcons/clock';
import Configuration from "../../../../config/configuration";


export const Heading = <><span style={{ color: 'var(--primary-color)' }}>CONTACT</span> US</>

export const VALIDATE_NAME = "Name is required";
export const VALIDATE_NAME_NUMBERS = "Name should not contain numbers and symbols";
export const VALIDATE_NAME_LENGTH = "Name should be at least 3 characters";
export const VALIDATE_NAME_MAX = "Name should not exceed 30 characters";
export const VALIDATE_WHITE_SPACE = "Name should not contain blank spaces"
export const VALIDATE_NAME_MAXLENGTH = "Name should not contain blank spaces"

// Form Validations Schema: Email
export const VALIDATE_EMAIL = "Email is required";
export const VALIDATE_EMAIL_INVALID = "Invalid email address";
export const NUMBER_NOT_ALLOWED_EMAIL = "Email should not start with a number";
export const SPACE_EMAIL_VALIDATION = 'Email should not contain blank spaces';

// Form Validations Schema: Description
export const VALIDATE_DESCRIPTION = "Description is required";
export const CHARACTER_VALIDATION = "Description should not exceed 100 characters";
export const DESCRIPTION_SPACE_VALIDATION = "Description should not contain blank spaces";
export const DESCRIPTION_MIN_VALIDATION = "Description should be at least 26 characters";

export const ContactFormData = [
    { label: "Name", placeholder: "Enter Your Name" },
    { label: "Email", placeholder: "Enter your email" },
]

export const CompanyInformation = [
    { icon: <Mail />, details: Configuration.MAILURL },
    //  {icon:<Dial/>,details:"91+ 9355775634"},
    { icon: <LinkedinWhite />, details: Configuration.LINKEDIN_TEXT },
    { icon: <Location />, details: Configuration.MAIN_ADDRESS },
    { icon: <Clock />, details: Configuration.OFFICE_TIMINGS },
]
